import * as Api            from './api'
import { apiPath }         from './config'
import { credentials }     from './project-utils/credentials-cookie'
import { failOnHttpError } from './utils'

export const api = new Api.BLCApi({
  apiKey:   credentials.token,
  basePath: apiPath,
})

/* TODO: for company-tabs add-another-account & edit-company-details */
// export const companyApi = new Api.CompanyApi({
//   apiKey:   credentials.token,
//   basePath: apiPath,
// })

export const registrationApi = new Api.RegisterApi({
  basePath: apiPath,
})

export const getProcessUsers = (studentId, teacherId, programId) => {
  /*
   * This is sorta weird, if somebody finds a better solution to this
   * go ahead and implement it.
   *
   * The reason this was implemented as a single request is so that
   * nobody would have to keep track of two different communication states.
   * However Promise.all does not do the job here because the only scenario
   * we want this request to fail at is if BOTH user requests return with an
   * error.
   *
   * The reason for this is that some user-roles need access to both these
   * users and some only to one or the other.
   *
   * Ergo, we succeed on either one success and only fail on both failing.
   * */
  return new Promise((resolve, reject) => {
    
    let teacher, teacherArrived, teacherFailed
    let student, studentArrived, studentFailed

    api.getUser(studentId, programId)
       .then(r => {
         if (teacherArrived) {
           resolve([ r, teacher ])
         } else if (teacherFailed) {
           resolve([ r ])
         }

         studentArrived = true
         student = r
       })
       .catch(e => {
         if (teacherFailed) {
           reject(e)
         }

         studentFailed = true
       })

    api.getUser(teacherId,programId)
       .then(r => {
         if (studentArrived) {
           resolve([ r, student ])
         } else if (studentFailed) {
           resolve([ r ])
         }

         teacherArrived = true
         teacher = r
       })
       .catch(e => {
         if (studentFailed) {
           reject(e)
         }

         teacherFailed = true
       })
  })
}

export const uploadResource = (processId: number, file: File) => {
  const formDataSim = new FormData()
  formDataSim.append('file', file)

  return window.fetch(
    `${apiPath}/programs/processes/${processId}/resources`,
    {
      method: 'POST',
      headers:
              {
                Authorization: credentials.token,
              } as any,
      body:   formDataSim,
    }
  ).then(failOnHttpError)
}



// WEBPACK FOOTER //
// ./src/client.ts